// src/pages/team/CoinActualites.jsx
// Coin « Actualités / Éditorial » — espace de travail délégable à une petite main.
// Accès : route staff (RequireStaff = admin/team) + le membre doit avoir le coin
// 'actualites' dans profiles.team_coins (l'admin a tous les coins).
import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { hasCoin, COIN_BY_KEY } from "../../config/teamCoins";
import NewsletterValidationQueue from "../../components/team/NewsletterValidationQueue";

const COIN = COIN_BY_KEY.actualites;

export default function CoinActualites() {
  const { profile, profileLoading } = useAuth();

  if (profileLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f6f6f4]">
        <div className="h-10 w-10 animate-spin rounded-full border-b-2 border-gray-900" />
      </div>
    );
  }

  if (!hasCoin(profile, "actualites")) {
    return (
      <div className="mx-auto max-w-lg px-6 py-24 text-center">
        <div className="text-4xl" aria-hidden>🔒</div>
        <h1 className="mt-4 font-serif text-2xl font-semibold text-gray-900">Accès non accordé</h1>
        <p className="mt-2 text-sm text-gray-600">
          Le coin « Actualités / Éditorial » ne vous a pas été attribué. Demandez à un administrateur
          de vous l'accorder depuis « Équipe &amp; accès ».
        </p>
        <Link to="/team/dashboard" className="mt-6 inline-block rounded-lg bg-gray-900 px-5 py-2.5 text-sm font-medium text-white hover:bg-gray-800">
          Retour à mon espace
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f6f6f4]">
      <header className="border-b border-gray-200 bg-white">
        <div className="mx-auto flex max-w-[1200px] items-center justify-between gap-4 px-6 py-5">
          <div className="flex items-center gap-3">
            <span className="text-3xl" aria-hidden>{COIN.emoji}</span>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.16em] text-amber-700">Coin Éditorial</p>
              <h1 className="font-serif text-2xl font-semibold text-gray-950">{COIN.title}</h1>
            </div>
          </div>
          <Link to="/team/dashboard" className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
            ← Mon espace
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-[1200px] px-6 py-7">
        <p className="mb-5 max-w-2xl text-sm text-gray-600">
          Validez les actualités des galeries — qu'elles proviennent de l'extraction IA des newsletters
          ou d'une saisie manuelle. Contrôlez le contenu, corrigez si besoin, puis publiez.
        </p>
        <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm lg:p-6">
          <NewsletterValidationQueue />
        </div>
      </main>
    </div>
  );
}
